import * as preact from "preact";

import { ChallengeProps } from "practiceUtils";
import * as languageMap from "shared/languageMap";
import stores from "stores/stores";
import UserWordStore from "stores/UserWordStore";

interface State {}

class IntroChallengeView extends preact.Component<ChallengeProps, State> {
  userWords: UserWordStore[];

  render() {
    const { userWord, completedCallback, reportRecallEase } = this.props;

    return (
      <div>
        <h2>Write a sentence using "{userWord.state.value.word}"</h2>
        <div>
          <p>Here's an example sentence:</p>
          {userWord.state.value.contexts ? (
            <p>{userWord.state.value.contexts[0].text}</p>
          ) : (
            <p>No contexts!</p>
          )}
        </div>
        <p>
          <input
            type="text"
            placeholder={`Type in ${
              languageMap.map[stores.user.currentLearningLanguage.value].english
            }`}
          ></input>
          <button
            onClick={() => {
              completedCallback({
                type: "show-feedback",
                correct: "yes",
              });
              reportRecallEase(2, 0.5);
            }}
          >
            Self-report: Hard
          </button>
          <button
            onClick={() => {
              completedCallback({
                type: "show-feedback",
                correct: "yes",
              });
              reportRecallEase(4, 0.5);
            }}
          >
            Self-report: Easy
          </button>
        </p>
      </div>
    );
  }
}

export default IntroChallengeView;
